import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface CheckboxProps
   extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
   theme?: "white" | "dark";
}

const Checkbox = React.forwardRef<
   React.ElementRef<typeof CheckboxPrimitive.Root>,
   CheckboxProps
>(({ className, theme = "white", ...props }, ref) => {
   const base =
      "peer size-[1.125rem] shrink-0 rounded-[0.25rem] transition-colors"; // 18px, 4px radius

   const border = {
      white: "border border-custom-dark",
      dark: "border border-custom-white/60",
   };

   const checked = {
      white: "data-[state=checked]:bg-custom-dark data-[state=checked]:text-custom-white",
      dark: "data-[state=checked]:bg-custom-white data-[state=checked]:text-custom-dark",
   };

   return (
      <CheckboxPrimitive.Root
         ref={ref}
         className={cn(base, border[theme], checked[theme], className)}
         {...props}
      >
         <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
            <Check className="w-3 h-3" /> {/* 12px icon */}
         </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
   );
});

Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };
